'use client';

import { Layout } from '@bridebook/models/source/models/Weddings.types';
import { useSelector } from '@bridebook/web/lib/utils';
import { getWebsiteLayoutVersion } from '@bridebook/web/lib/weddings/selectors';

/**
 * Is Motif the wedding's active layout — drives all Motif-specific chrome (design panel branch, mobile
 * app bar, mobile action bar). Entry points are gated separately by the AB test
 * (useIsAiWWThemeGeneratorEnabled), never this hook, so a couple whose layout is already Motif keeps
 * a working panel even if the experiment turns them off.
 */
export const useIsMotifActive = (): boolean =>
  useSelector(getWebsiteLayoutVersion) === Layout.Motif;
